export default class UnavailableTypesModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
